import { useDeviceType } from '@cian/ui-kit';

import { ISuggestProps } from './types';

import { SuggestDesktop } from './components/SuggestDesktop/SuggestDesktop';
import { SuggestMobile } from './components/SuggestMobile/SuggestMobile';

const suggestComponent = { phone: SuggestMobile, tablet: SuggestMobile, desktop: SuggestDesktop };

/** Локальная копия ui-kit `Suggest` для offer-calculator (регион покупки). Вёрстку можно менять отдельно от пакета. */
export const OfferCalculatorSuggest = <T,>(props: ISuggestProps<T>) => {
  const deviceType = useDeviceType();
  const AdaptiveComponent = suggestComponent[deviceType];

  return <AdaptiveComponent {...props} />;
};
